class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 13.5a1.001 1.001 0 1 0-.002-2.002A1.001 1.001 0 0 0 8 13.5Z"></path><path d="M15 1.706 14.291 1 1 14.291l.706.709 5.34-5.343A2.968 2.968 0 0 1 8.64 9.57c.531.114 1.02.374 1.411.748l.709-.706A3.98 3.98 0 0 0 8.197 8.51L9.89 6.814a5.97 5.97 0 0 1 2.282 1.383l.709-.706a6.952 6.952 0 0 0-2.214-1.451l1.497-1.5a8.964 8.964 0 0 1 2.128 1.537L15 5.371V5.37a10.045 10.045 0 0 0-2.097-1.57L15 1.706ZM7.338 6.537l1.023-1.02c-.12-.006-.24-.017-.363-.017a6.954 6.954 0 0 0-4.883 1.994l.706.709a5.997 5.997 0 0 1 3.517-1.666ZM8 3.5c.711 0 1.423.089 2.114.26l.823-.82a10.016 10.016 0 0 0-5.306-.157A9.995 9.995 0 0 0 1 5.369v.011l.7.703A8.946 8.946 0 0 1 8 3.5Z"></path></svg>';
  }
}
const t = "pi-mod-offline";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
